import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { ContatoIniciativaPipe } from './contato-iniciativa.pipe';
import { ContatoIniciativaIconPipe } from './contato-iniciativa-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ContatoIniciativaPipe,
        ContatoIniciativaIconPipe
    ],
    exports: [
        ContatoIniciativaPipe,
        ContatoIniciativaIconPipe
    ],
    providers: [
        ContatoIniciativaPipe,
        ContatoIniciativaIconPipe
    ]
})
export class ContatoIniciativaPipeModule { }
